import Button from "../../Components/Button";
import Modal from "../../Components/Modal";

type DiscoveryHubConfirmModalProps = {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const DiscoveryHubConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  onConfirm,
  onCancel,
}: DiscoveryHubConfirmModalProps) => (
  <Modal
    isOpen={isOpen}
    toggle={onCancel}
    title={title}
    size="md"
    usePortal
    footer={
      <div className="flex justify-end gap-2">
        <Button variant="secondary" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant="primary" onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </div>
    }
  >
    <p className="text-sm text-gray-700 mb-0 leading-relaxed">{message}</p>
  </Modal>
);

export default DiscoveryHubConfirmModal;
